"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addNumberWithRounding(num1, num2 = 0) {
    const number1 = num1 * Math.pow(10, 15);
    const number2 = num2 * Math.pow(10, 15);
    const total = Math.round(number1 + number2) / Math.pow(10, 15);
    return total;
}
exports.default = addNumberWithRounding;
//# sourceMappingURL=addNumberWithRounding.js.map